"use strict";

Shopify.theme.jsProcessPage = {
    openTab: function openTab($section) {
        return $section.find('.process__page-tab.tab-active')
    },
    init: function init($section) {
        Shopify.theme.jsProcessPage = $.extend(this, Shopify.theme.getSectionData($section)); // Selectors
        this.initTabs($section)

    },
    initTabs: function initTabs($section) {
        let $nav = $section.find('.process__page-navs');
        let $link = $nav.find('.process__page-nav');
        let $tabs = $section.find('.process__page-tabs')
        const params = (new URL(location)).searchParams;
      	let type = params.get('type')
        console.log(type)
        if(type){
          let $target = $(`[data-tab="${type}"]`)
          console.log($target)
          if($target.length){
          	Shopify.theme.jsProcessTimeline.resetTop()
            Shopify.theme.jsProcessPage.switchPage($target)
          }
        }
        $link.on('click', function(e) {
            Shopify.theme.jsProcessTimeline.resetTop()
            Shopify.theme.jsProcessPage.switchPage(e)
        });
        Shopify.theme.jsProcessPage.processHeight()



    },
    processHeight: function processHeight($section, cb) {
        $section = $section ? $section : $('.jsProcessPage')
        let $tabs = $section.find('.process__page-tabs')
        let $active_tab = Shopify.theme.jsProcessPage.openTab($section)
        if(isScreenSizeLarge()){
           $tabs.css('padding-bottom', $active_tab.find('.nav__wrapper').height() + 'px') 
        }else{
          $tabs.css('padding-bottom', $active_tab.find('.nav__wrapper').height()+ 48 + 'px')
        }
        
        setTimeout(function() {
          if(isScreenSizeLarge()){
             $tabs.css('padding-bottom', $active_tab.find('.nav__wrapper').height() + 'px') 
          }else{
            $tabs.css('padding-bottom', $active_tab.find('.nav__wrapper').height()+ 48 + 'px')
          }
          if (cb) {
              cb()
          }
        }, 500)

    },
    switchPage: function switchPage(e) {
        let $item = e
        if(e.target){
        	$item = $(e.target)
        }
        let $section = $item.parents('.jsProcessPage')
        let $nav = $section.find('.process__page-navs');
        let $link = $nav.find('.process__page-nav');
        let $tabs = $section.find('.process__page-tabs')
        let navH = $nav.innerHeight();
        let isOpen = true;
        let hasT = false;
        let $self = $item;
		
        $('#shopify-section-index__contact-form').css('opacity', 0)


        $link.removeClass('active')
        $self.addClass('active')
        var tab_handle = $self.data('tab');
        var $current_tab = $tabs.find(`.process__page-tab[data-tab="${tab_handle}"]`);
        var $active_tab = $tabs.find('.process__page-tab.tab-active');
        if (!hasT) {
            if ($current_tab == $active_tab) {
                return false;
            }

            $active_tab
                .addClass('tab-hidden')
                .removeClass('tab-active');

            $current_tab.addClass('tab-active').removeClass('tab-hidden');
            Shopify.theme.jsProcessTimeline.unload($active_tab)
            Shopify.theme.jsProcessTimeline.unload($current_tab)
            Shopify.theme.jsProcessTimeline.initTimeline($current_tab)

            function success() {
                $('#shopify-section-index__contact-form').animate({
                    opacity: 1
                }, 700)
            }
            Shopify.theme.jsProcessPage.processHeight(null, success)

        }

        return false;
    },
    unload: function unload($section) {}
};